<script>
import { CONSTANT } from '../../../utils/constant.js'
import ConfigurationService from '../configuration.service'
import sharedService from '../../../utils/shared-service'

const configurationService = new ConfigurationService()
export default {
  data () {
    return {
      CONSTANT: CONSTANT,
      configurationService: configurationService
    }
  },
  computed: {
    cryptoFormat: {
      get () {
        return this.$store.state.configuration.tokenization.cryptoFormat
      }
    },

    dynamicCVC2Support: {
      get () {
        return this.$store.state.configuration.tokenization.dynamicCVC2Support
      },
      set (value) {
        this.$store.commit('updateDynamicCVC2Support', value)
        sharedService.updateCheckoutButton(false)
      }
    },

    validityPeriodMinutes: {
      get () {
        return this.$store.state.configuration.tokenization.validityPeriodMinutes
      },
      set (value) {
        this.$store.commit('updateValidityPeriodMinutes', value)
        sharedService.updateCheckoutButton(false)
      }
    },

    maSelected: {
      get () {
        if (this.$store.getters.dynamicDataTypeMastercard) {
          return this.$store.getters.dynamicDataTypeMastercard
        }
        return CONSTANT.TOKENIZATION_OPTIONS.MASTERCARD['UCAF - CARD APPLICATION CRYPTOGRAM SHORT FORM']
      },

      set (value) {
        this.$store.commit('updateDynamicDataTypeMastercard', value)
        sharedService.updateCheckoutButton(false)
      }
    },

    visaSelected: {
      get () {
        if (this.$store.getters.dynamicDataTypeVisa) {
          return this.$store.getters.dynamicDataTypeVisa
        }
        return CONSTANT.TOKENIZATION_OPTIONS.VISA['TAVV - Transaction Authentication Verification Value']
      },

      set (value) {
        this.$store.commit('updateDynamicDataTypeVisa', value)
        sharedService.updateCheckoutButton(false)
      }
    },

    amexSelected: {
      get () {
        if (this.$store.getters.dynamicDataTypeAmex) {
          return this.$store.getters.dynamicDataTypeAmex
        }
        return CONSTANT.TOKENIZATION_OPTIONS.AMEX['DTD - CARD SECURITY CODE']
      },

      set (value) {
        this.$store.commit('updateDynamicDataTypeAmex', value)
        sharedService.updateCheckoutButton(false)
      }
    },

    discoverSelected: {
      get () {
        if (this.$store.getters.dynamicDataTypeDiscover) {
          return this.$store.getters.dynamicDataTypeDiscover
        }
        return CONSTANT.TOKENIZATION_OPTIONS.DISCOVER['CARD APPLICATION CRYPTOGRAM LONG FORM']
      },

      set (value) {
        this.$store.commit('updateDynamicDataTypeDiscover', value)
        sharedService.updateCheckoutButton(false)
      }
    }

  },
  methods: {
    /**
     * change tokenization options and update in store
     */
    toggleCryptoArray () {
      configurationService.toggleArray(CONSTANT.CONFIG.CRYPTO_OPTIONS['dcvc2'].DCVC2, this.cryptoFormat, false)
      this.$store.commit('updateCryptoFormat', this.cryptoFormat)
    }
  }
}
</script>
<template>
  <div id="configuration-tokenization">
    <div class="card mb-4">
      <h5
        id="headingDynamicTokenVerification"
        aria-controls="collapseDynamicTokenVerification"
        aria-expanded="true"
        class="card-header collapsed cursor-pointer"
        data-target="#collapseDynamicTokenVerification"
        data-toggle="collapse"
      >
        <span class="font-weight-bold">{{ $t('header.dynamicTokenVerification') }}</span>
        <span class="collapsible-arrow pull-right cursor-pointer" />
      </h5>
      <div
        id="collapseDynamicTokenVerification"
        aria-labelledby="headingDynamicTokenVerification"
        class="card-body collapse show"
      >
        <div
          id="validity-period-minutes"
          class="form-group row"
        >
          <label
            class="col col-form-label"
            for="input-validity-period-minutes"
          >
            {{ $t('label.validityPeriodMinutes') }}
          </label>
          <div class="col">
            <input
              id="input-validity-period-minutes"
              v-model="validityPeriodMinutes"
              class="form-control"
              data-test="validityPeriodMinutes"
              min="0"
              type="number"
            >
          </div>
        </div>

        <div
          id="cvc2Support"
          class="form-group"
        >
          <h5>{{ $t('label.dynamicCVC2Support') }}</h5>
          <label>
            {{ $t('description.dynamicCVC2Support') }}
          </label>
        </div>
        <div class="form-check">
          <label
            class="form-check-label"
            for="checkbox-cvc2-support"
          >
            <input
              id="checkbox-cvc2-support"
              v-model="dynamicCVC2Support"
              class="form-check-input"
              data-test="dynamicCVC2Support"
              type="checkbox"
              @click="toggleCryptoArray()"
            >
            {{ $t('label.cvc2Support') }}
          </label>
        </div>
      </div>
    </div>

    <div class="card">
      <h5
        id="headingDSRP"
        aria-controls="collapseDSRP"
        aria-expanded="true"
        class="card-header collapsed cursor-pointer"
        data-target="#collapseDSRP"
        data-toggle="collapse"
      >
        <span class="font-weight-bold">{{ $t('header.DSRP') }}</span>
        <span class="collapsible-arrow pull-right cursor-pointer" />
      </h5>

      <div
        id="collapseDSRP"
        class="card-body collapse"
      >
        <h5 class="mb-3">
          {{ $t('description.cryptoGramOptions') }}
        </h5>
        <div id="maDynamicDataType">
          <div class="form-group row">
            <label
              class="col-sm-3 col-form-label"
              for="maCryptoTypeSelected"
            >{{ $t('label.MASTERCARD') }}</label>
            <div class="col-sm-9">
              <select
                id="maCryptoTypeSelected"
                v-model="maSelected"
                :data-selected="maSelected"
                class="form-control"
                data-test="maCryptoTypeSelected"
                required=""
                title="Mastercard Crypto Options"
              >
                <option
                  v-for="(item, key) in CONSTANT.TOKENIZATION_OPTIONS.MASTERCARD"
                  :key="key"
                  :value="item"
                >
                  {{ key }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div id="visaDynamicDataType">
          <div class="form-group row">
            <label
              class="col-sm-3 col-form-label"
              for="maCryptoTypeSelected"
            >{{ $t ('label.VISA') }}</label>
            <div class="col-sm-9">
              <select
                id="visaCryptoTypeSelected"
                v-model="visaSelected"
                :data-selected="visaSelected"
                class="form-control"
                data-test="visaCryptoTypeSelected"
                required=""
                title="Visa Crypto Options"
              >
                <option
                  v-for="(item, key) in CONSTANT.TOKENIZATION_OPTIONS.VISA"
                  :key="key"
                  :value="item"
                >
                  {{ key }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div id="amexDynamicDataType">
          <div class="form-group row">
            <label
              class="col-sm-3 col-form-label"
              for="amexCryptoTypeSelected"
            >{{ $t ('label.AMEX') }}</label>
            <div class="col-sm-9">
              <select
                id="amexCryptoTypeSelected"
                v-model="amexSelected"
                :data-selected="amexSelected"
                class="form-control"
                data-test="amexCryptoTypeSelected"
                required=""
                title="Amex Crypto Options"
              >
                <option
                  v-for="(item, key) in CONSTANT.TOKENIZATION_OPTIONS.AMEX"
                  :key="key"
                  :value="item"
                >
                  {{ key }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div id="discoverDynamicDataType">
          <div class="form-group row">
            <label
              class="col-sm-3 col-form-label"
              for="discoverCryptoTypeSelected"
            >{{ $t ('label.DISCOVER') }}</label>
            <div class="col-sm-9">
              <select
                id="discoverCryptoTypeSelected"
                v-model="discoverSelected"
                :data-selected="discoverSelected"
                class="form-control"
                data-test="discoverCryptoTypeSelected"
                required=""
                title="Discover Crypto Options"
              >
                <option
                  v-for="(item, key) in CONSTANT.TOKENIZATION_OPTIONS.DISCOVER"
                  :key="key"
                  :value="item"
                >
                  {{ key }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
